export default __webpack_public_path__ + "static/media/Bids.e6d93ed2.svg";